import React, { useCallback, useState } from 'react';
import { useAuth, ValidatorProvider } from 'react-admin-base';
import { FormattedMessage, useIntl } from "react-intl";
import { Link } from 'react-router-dom';
import { Alert, Col, Form, FormGroup, Input, Label, Row } from 'reactstrap';
import { Validator, LoadingButton, PasswordInput } from "react-admin-base-bootstrap";
import Layout from '../Layout.js';
export default function Reset() {
    const [api] = useAuth();
    const intl = useIntl();
    const [email, setEmail] = useState('');
    const [step, setStep] = useState(1);
    const [code, setCode] = useState('');
    const [password, setPassword] = useState('');
    const [signature, setSignature] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const handleSubmit = useCallback(async function (e) {
        e.preventDefault();
        if (loading)
            return false;
        setError(null);
        setLoading(true);
        try {
            switch (step) {
                case 1:
                    let _signature = (await api.free.post('/reset', { email })).data;
                    setStep(2);
                    setSignature(_signature);
                    break;
                case 2:
                    await api.free.get(signature, { params: { code } });
                    setStep(3);
                    setPassword('');
                    break;
                case 3:
                    await api.free.post(signature, { email, password }, { params: { code } });
                    await api.log_in(email, password);
                    setStep(1);
                    break;
            }
        }
        catch (e) {
            setError(e);
        }
        finally {
            setLoading(false);
        }
    }, [signature, api, code, email, step, password, setError, loading]);
    const changeEmail = useCallback(function (e) {
        e.preventDefault();
        setStep(1);
        setEmail('');
        setCode('');
    }, [setStep, setEmail, setCode]);
    return React.createElement(Layout, null,
        React.createElement(ValidatorProvider, null,
            React.createElement(Form, { onSubmit: handleSubmit },
                React.createElement("div", { className: "text-center" },
                    React.createElement("div", { className: "mb-5" },
                        React.createElement("p", { className: "text-center" },
                            React.createElement(FormattedMessage, { id: "RESET_PASSWORD" })))),
                React.createElement(FormGroup, { className: "auth-form-group-custom" },
                    React.createElement("i", { className: "ri-user-2-line auti-custom-input-icon" }),
                    React.createElement(Label, null,
                        React.createElement(FormattedMessage, { id: "EMAIL" })),
                    React.createElement(Validator, { name: "email", type: "required|email" },
                        React.createElement(Input, { type: "text", value: email || '', label: "Email", onChange: a => {
                                setEmail(a.currentTarget.value);
                                setError(null);
                            }, disabled: loading, autoComplete: "username" }))),
                step === 2 && React.createElement(React.Fragment, null,
                    React.createElement(FormGroup, { className: "auth-form-group-custom" },
                        React.createElement("i", { className: "ri-lock-2-line auti-custom-input-icon" }),
                        React.createElement(Label, null,
                            React.createElement(FormattedMessage, { id: "AUTH_CODE" })),
                        React.createElement(Validator, { name: "code", type: "required" },
                            React.createElement(Input, { type: "text", value: code || "", onChange: a => setCode(a.currentTarget.value), placeholder: intl.formatMessage({ id: "AUTHORIZATION_CODE" }), disabled: !!loading }))),
                    React.createElement("p", { className: "text-left font-14" },
                        React.createElement(FormattedMessage, { id: "ENTER_AUTH_CODE", values: { email: React.createElement("b", null, email) } })),
                    React.createElement("p", { className: "text-left font-14" },
                        React.createElement(FormattedMessage, { id: "CHANGE_EMAIL", values: { a: text => React.createElement("a", { href: "#", onClick: changeEmail }, text) } }))),
                step === 3 && React.createElement(PasswordInput, { className: "auth-form-group-custom", icon: "ri-lock-2-line auti-custom-input-icon", value: password || '', onChange: a => {
                        setPassword(a);
                        setError(null);
                    }, disabled: loading, required: true }),
                error && React.createElement(Alert, { color: "danger", toggle: () => setError(null) }, error.message),
                React.createElement(Row, { className: "text-center mt-4" },
                    React.createElement(Col, null,
                        React.createElement(Link, { to: "/login", className: "btn btn-danger btn-lg w-100 d-block me-5 text-white" },
                            React.createElement(FormattedMessage, { id: "BACK" }))),
                    React.createElement(Col, null,
                        React.createElement(LoadingButton, { type: "submit", size: "lg", color: "primary", block: true, loading: loading },
                            React.createElement(FormattedMessage, { id: "SUBMIT" })))))));
}
